import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { AdministrativeArea, GetCountriesResponse, GetCountryStatesResponse } from "./country.model";

export const ACTION_PREFIX = "[Country]";
export const COUNTRY_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,
	getAllStates: `${ACTION_PREFIX} Get All States`,
	getAllStatesFromContent: `${ACTION_PREFIX} Get All States From Content`,
	getAllStatesSuccess: `${ACTION_PREFIX} Get All States Success`,
	getAllStatesFromContentSuccess: `${ACTION_PREFIX} Get All States From Content Success`,
	getAllStatesFail: `${ACTION_PREFIX} Get All States Fail`,
	getAllStatesFromContentFail: `${ACTION_PREFIX} Get All States From Content Fail`,
	getAllBirthCountries: `${ACTION_PREFIX} Get All Birth Countries`,
	getAllBirthCountriesSuccess: `${ACTION_PREFIX} Get All Birth Countries Success`,
	getAllBirthCountriesFail: `${ACTION_PREFIX} Get All Birth Countries Fail`,
	getAdministrativeAreas: `${ACTION_PREFIX} Get Administrative Areas`,
	getAdministrativeAreasSuccess: `${ACTION_PREFIX} Get Administrative Areas Success`,
	getAdministrativeAreasFail: `${ACTION_PREFIX} Get Administrative Areas Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - use mfe svc-content CountryService instead
 */
export class CountryAction {
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getTransformedCountries)" instead
	 */
	getAll(): Action {
		return createCachedGetAction({
			type: COUNTRY_ACTION_TYPE.getAll,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getTransformedCountries)" instead
	 */
	getAllSuccess(response: GetCountriesResponse): ActionWithPayload {
		return createGetSuccessAction({
			type: COUNTRY_ACTION_TYPE.getAllSuccess,
			payload: response,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getTransformedCountries)" instead
	 */
	getAllFail(error: AppError | Error): ActionWithPayload {
		return {
			type: COUNTRY_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryStates)" instead
	 */
	getAllStates(country?: string): Action {
		return createCachedGetAction({
			type: COUNTRY_ACTION_TYPE.getAllStates,
			payload: country,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryStatesFromContent)" instead
	 */
	getAllStatesFromContent(jurisdiction: string): Action {
		return createCachedGetAction({
			type: COUNTRY_ACTION_TYPE.getAllStatesFromContent,
			payload: jurisdiction,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryStates)" instead
	 */
	getAllStatesSuccess(response: GetCountryStatesResponse): ActionWithPayload {
		return createGetSuccessAction({
			type: COUNTRY_ACTION_TYPE.getAllStatesSuccess,
			payload: response,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryStatesFromContent)" instead
	 */
	getAllStatesFromContentSuccess(response: GetCountryStatesResponse): Action {
		return createGetSuccessAction({
			type: COUNTRY_ACTION_TYPE.getAllStatesFromContentSuccess,
			payload: response,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryStates)" instead
	 */
	getAllStatesFail(error: AppError | Error): ActionWithPayload {
		return {
			type: COUNTRY_ACTION_TYPE.getAllStatesFail,
			payload: error,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getCountryStatesFromContent)" instead
	 */
	getAllStatesFromContentFail(error: AppError | Error): ActionWithPayload {
		return {
			type: COUNTRY_ACTION_TYPE.getAllStatesFromContentFail,
			payload: error,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getBirthCountries)" instead
	 */
	getAllBirthCountries(): Action {
		return createCachedGetAction({
			type: COUNTRY_ACTION_TYPE.getAllBirthCountries,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getBirthCountries)" instead
	 */
	getAllBirthCountriesSuccess(response: GetCountriesResponse): ActionWithPayload {
		return createGetSuccessAction({
			type: COUNTRY_ACTION_TYPE.getAllBirthCountriesSuccess,
			payload: response,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getBirthCountries)" instead
	 */
	getAllBirthCountriesFail(error: AppError | Error): ActionWithPayload {
		return {
			type: COUNTRY_ACTION_TYPE.getAllBirthCountriesFail,
			payload: error,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getAdministrativeAreasByCountryCode)" instead
	 */
	getAdministrativeAreas(countryCode: string): Action {
		return createCachedGetAction({
			type: COUNTRY_ACTION_TYPE.getAdministrativeAreas,
			payload: countryCode,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getAdministrativeAreasByCountryCode)" instead
	 */
	getAdministrativeAreasSuccess(response: AdministrativeArea, countryCode: string): ActionWithPayload {
		return createGetSuccessAction({
			type: COUNTRY_ACTION_TYPE.getAdministrativeAreasSuccess,
			payload: {
				response,
				countryCode,
			},
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - use "document.obgEventBus.retrieve(ContentValue.getAdministrativeAreasByCountryCode)" instead
	 */
	getAdministrativeAreasFail(error: AppError | Error): ActionWithPayload {
		return {
			type: COUNTRY_ACTION_TYPE.getAdministrativeAreasFail,
			payload: error,
		};
	}
}
